import React from "react";
import {
  CellInfo,
  TableCellRenderer
} from "react-table";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import { ImageWrapper } from "src/core/shared/components/S3";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import BrandedImage from "src/core/shared/components/BrandedImage";

export interface PromotionTableProps {
  ActionButton?: TableCellRenderer;
}

/**
 * Promotion table columns
 */
export const promotionTableColumns = (params: PromotionTableProps): CustomTableColumn[] => {
  const promotionColumnsAdmin: CustomTableColumn[] = [
    globalTableColumns.id(),
    {
      Header: "Image",
      accessor: "image",
      width: 80,
      filterable: false,
      sortable: false,
      Cell: (cellProps: CellInfo) => {
        return (
          <ImageWrapper className={cellProps.value ? "image-wrapper hasImage" : "placeholder image-wrapper"}>
            <BrandedImage
              s3Key={cellProps.value}
              alt={cellProps.original.description}
              level="public"
            />
          </ImageWrapper>
        );
      }
    },
    globalTableColumns.standardText({
      Header: "Heading",
      accessor: "name"
    }),
    globalTableColumns.standardText({
      Header: "Template",
      accessor: "template"
    }),
    globalTableColumns.actions({ cell: params.ActionButton })
  ];

  return promotionColumnsAdmin;
};
